import { Entity } from "../core/entity";
import { ConfirmationDto } from "./dtos/confirmation.dto";

export class Confirmation extends Entity<ConfirmationDto> {
  constructor(dto: ConfirmationDto) {
    super(dto, "owner");
  }
}
